import {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";

/** 구 URL 호환 — 목록 화면에서 모달로 열기 */
function CompareUpdate() {
    const {month} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (!month) {
            navigate("/evaluation/slaCompare", {replace: true});
            return;
        }
        navigate("/evaluation/slaCompare", {
            replace: true,
            state: {slaEditor: {mode: "update", month, monthLabel: month}},
        });
    }, [month, navigate]);

    return null;
}

export {CompareUpdate};
